import LoginPage from './pages/login.vue'
import HomePage from './pages/home.vue'
import AboutPage from './pages/about.vue'
import FormPage from './pages/form.vue'

import DynamicRoutePage from './pages/dynamic-route.vue'
import RequestAndLoad from './pages/request-and-load.vue'
import NotFoundPage from './pages/404.vue'

import VendorAdminDashboardPage from './pages/vendor-admin-dash.vue'
import EventListPage from './pages/event-list.vue'
import EventEditPage from './pages/event-edit.vue'
import FoodListPage from './pages/food-list.vue'
import FoodEditPage from './pages/food-edit.vue'
import OrderListPage from './pages/order-list.vue'

import firebase from './firebase'
import { Router } from 'framework7/modules/router/router'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function requireUser (this: Router.Router, routeTo: any, routeFrom: any, resolve: any, reject: any) {
  if (firebase.auth().currentUser) {
    // console.log('requireUser pass')
    resolve()
  } else {
    // console.log('requireUser failed')
    reject('Login required')
    // App instance
    // const f7app = this.app
    this.navigate('/login')

    // f7app.loginScreen.
    // f7app.loginScreen.open('#my-login-screen')
  }
}

export default [
  {
    path: '/login',
    component: LoginPage
  },
  {
    path: '/vendor-admin-dash',
    component: VendorAdminDashboardPage,
    beforeEnter: requireUser
  },
  {
    path: '/event-list/:eventId',
    component: EventEditPage,
    beforeEnter: requireUser
  },
  {
    path: '/event-list',
    component: EventListPage,
    beforeEnter: requireUser
  },
  {
    path: '/food-list/:foodId',
    component: FoodEditPage,
    beforeEnter: requireUser
  },
  {
    path: '/food-list',
    component: FoodListPage,
    beforeEnter: requireUser
  },
  {
    path: '/order-list',
    component: OrderListPage,
    beforeEnter: requireUser
  },
  {
    path: '/home',
    component: HomePage,
    beforeEnter: requireUser
  },
  {
    path: '/about/',
    component: AboutPage
  },
  {
    path: '/form/',
    component: FormPage
  },
  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage
  },
  {
    path: '/request-and-load/user/:userId/',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    async: function (routeTo: any, routeFrom: any, resolve: any, reject: any) {
      // Router instance
      // eslint-disable-next-line @typescript-eslint/no-this-alias, @typescript-eslint/no-explicit-any
      const router: any = this

      // // App instance
      const app = router.app

      // // Show Preloader
      app.preloader.show()

      // console.log('routes async request-and-load user')

      // User ID from request
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const userId = routeTo.params.userId

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        const user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io'
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io'
            }
          ]
        }
        // Hide Preloader
        app.preloader.hide()

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad
          },
          {
            context: {
              user: user
            }
          }
        )
      }, 1000)
    }
  },
  {
    path: '(.*)',
    component: NotFoundPage
  }
]
